// Dictionnaire de traductions FR / EN — LUXE ORYVEA PREMIUM
export const DICT = {
  fr: {
    // Barre d'annonce
    "announce": "Livraison offerte dès 60€ d'achat · Produits premium · Résultats visibles",

    // Navigation
    "nav.accueil": "Accueil",
    "nav.femme": "Femme",
    "nav.homme": "Homme",
    "nav.coffrets": "Coffrets",
    "nav.serum": "Le Sérum",
    "nav.resultats": "Résultats",
    "nav.ingredients": "Ingrédients",
    "nav.avis": "Avis",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "nav.compte": "Compte",
    "nav.recherche": "Recherche",
    "nav.panier": "Panier",

    // Commun
    "common.discover_serum": "Découvrir le sérum",
    "common.learn_more": "En savoir plus",
    "common.add_to_cart": "Ajouter au panier",
    "common.order": "Commander",
    "common.secure_payment": "Paiement sécurisé",
    "common.free_shipping": "Livraison offerte",

    // Hero
    "hero.tagline": "Skin & Hair Excellence",
    "hero.description": "Le sérum d'exception qui hydrate, nourrit et renforce votre cuir chevelu pour des cheveux d'apparence plus forts, plus denses et visiblement en meilleure santé.",
    "hero.clients": "+1500 clients satisfaits",

    // Trust / Why
    "why.overline": "Pourquoi choisir",
    "why.discover_formula": "Découvrir la formule",
    "why.key_ingredients": "Ingrédients clés",
    "why.free_claims": "Miel · Actifs fortifiants · Fini glossy premium",

    // Résultats
    "results.title": "Résultats visibles",
    "results.note": "*Étude de satisfaction consommateur menée sur 8 semaines. Résultats déclaratifs, à titre indicatif.",
    "results.before": "Avant",
    "results.after": "Après 8 semaines",
    "results.illustration": "Photos d'illustration",

    // Offre
    "offer.overline": "Offre de lancement",
    "offer.desc": "Profitez de notre offre exclusive de lancement dès maintenant.",
    "offer.added": "Ajouté au panier",
    "offer.free_ship_title": "Livraison offerte",
    "offer.free_ship_sub": "Dès 60€ d'achat",
    "offer.secure_title": "Paiement sécurisé",
    "offer.secure_sub": "100% sécurisé",
    "offer.guarantee_title": "Satisfait ou remboursé",
    "offer.guarantee_sub": "30 jours",

    // Footer
    "footer.fast_ship": "Livraison rapide",
    "footer.fast_ship_sub": "2 à 4 jours ouvrés",
    "footer.support": "Service client",
    "footer.support_sub": "7j/7 à votre écoute",
    "footer.secure": "Paiement sécurisé",
    "footer.secure_sub": "100% sécurisé",
    "footer.returns": "Retours faciles",
    "footer.returns_sub": "30 jours pour changer d'avis",
    "footer.col_brand": "LUXE ORYVEA PREMIUM",
    "footer.our_story": "Notre histoire",
    "footer.our_formula": "Notre formule",
    "footer.contact": "Contact",
    "footer.help": "Aide",
    "footer.delivery": "Livraison",
    "footer.returns_link": "Retours",
    "footer.cgv": "Conditions générales",
    "footer.privacy": "Politique de confidentialité",
    "footer.contact_form": "Formulaire de contact",
    "footer.ritual": "Le Rituel",
    "footer.ritual_text": "Skin & Hair Excellence. Le rituel premium pour votre cuir chevelu.",
    "footer.rights": "Tous droits réservés",

    // Panier
    "cart.empty_title": "Votre panier est vide",
    "cart.empty_desc": "Découvrez le rituel premium LUXE ORYVEA.",
    "cart.title": "Votre panier",
    "cart.title_order": "Commander",
    "cart.promo": "Code promotionnel",
    "cart.promo_placeholder": "Entrez votre code",
    "cart.apply": "Appliquer",
    "cart.applied": "Code appliqué",
    "cart.billing": "Adresse de facturation & livraison",
    "cart.summary": "Récapitulatif",
    "cart.subtotal": "Sous-total",
    "cart.discount": "Remise",
    "cart.shipping": "Livraison",
    "cart.offered": "Offerte",
    "cart.total": "Total",
    "cart.proceed": "Passer commande",
    "cart.secure_btn": "Paiement sécurisé",
    "cart.redirect": "Redirection...",
    "cart.secure_note": "Paiement sécurisé via Stripe",
    "field.first_name": "Prénom",
    "field.last_name": "Nom",
    "field.email": "Adresse e-mail",
    "field.phone": "Numéro de téléphone",
    "field.address": "Adresse",
    "field.postal_code": "Code postal",
    "field.city": "Ville",
    "field.country": "Pays",

    // Produit
    "product.choose_format": "Choisissez votre format",
    "product.save": "Économisez",
    "product.description": "La nouvelle génération de sérum capillaire : brillance immédiate, effet miroir, nutrition au miel et actifs fortifiants. Une formule pensée pour favoriser la pousse, prendre soin du cuir chevelu et révéler des cheveux plus doux, plus résistants et visiblement lumineux.",
    "product.free_ship": "Livraison offerte",
    "product.secure": "Paiement 100% sécurisé",
    "product.adapted": "Adapté à différents types de cheveux",
    "product.actives": "Les actifs",
    "product.ingredients_title": "Ingrédients soigneusement sélectionnés",
    "product.fragrance_title": "Signature olfactive",
    "product.fragrance_name": "Floral · Miellée · Douce · Lumineuse",
    "product.fragrance_text": "Une signature sensorielle florale et miellée, douce et lumineuse, qui laisse les cheveux délicatement parfumés.",
    "product.benefits": "Bénéfices",
    "product.usage": "Utilisation",
    "product.shipping_info": "Informations livraison",
    "product.shipping_text": "Livraison offerte en France métropolitaine. Expédition sous 24–48h ouvrées. Paiement sécurisé.",
    "product.faq_title": "Questions fréquentes",
    "product.added": "ajouté au panier",

    // Formule
    "formule.overline": "La formule",
    "formule.title": "L'excellence au cœur de la formule",
    "formule.intro": "Une association d'actifs soigneusement sélectionnés pour prendre soin du cuir chevelu et révéler des cheveux d'apparence plus forts, plus sains et plus denses.",
    "formule.key_active": "Actif clé",
    "formule.disclaimer": "Soin cosmétique. LUXE ORYVEA PREMIUM ne présente aucune promesse médicale ni garantie de repousse.",

    // Notre histoire (Marque)
    "marque.overline": "Notre histoire",
    "marque.quote": "« LUXE ORYVEA PREMIUM est née d'une volonté simple : transformer le soin quotidien des cheveux en véritable rituel de beauté premium. »",
    "marque.p1": "Chaque détail — de la formule au flacon — a été pensé pour offrir une expérience à la hauteur des plus grandes maisons de cosmétique. Le premier chapitre de cette histoire s'écrit autour du soin du cuir chevelu, fondation d'une chevelure d'apparence plus forte et plus dense.",
    "marque.p2": "Notre approche conjugue élégance et exigence : des actifs soigneusement sélectionnés, une texture légère au fini non gras, et un rituel qui s'intègre naturellement à votre quotidien.",

    // Rituel
    "rituel.overline": "Le geste quotidien",
    "rituel.title_pre": "Votre rituel ",
    "rituel.title_suf": "",
    "rituel.intro": "Trois gestes simples pour intégrer le soin premium à votre routine.",
    "rituel.cta": "Commander le sérum",

    // Coffrets
    "coffrets.overline": "La collection",
    "coffrets.title_pre": "Coffrets ",
    "coffrets.intro": "Des écrins premium à offrir ou à s'offrir — femme, homme ou mixte.",
    "coffrets.out": "Épuisé",
    "coffrets.lowstock": "Bientôt épuisé",
    "coffrets.add": "Ajouter",
    "coffrets.only_left_pre": "Plus que ",
    "coffrets.only_left_suf": " en stock",
    "coffrets.edition": "Édition premium",
    "coffrets.added": "ajouté au panier",

    // Contact
    "contact.overline": "Contact",
    "contact.title": "Écrivez-nous",
    "contact.intro": "Une question sur le rituel LUXE ORYVEA ? Notre équipe vous répond.",
    "contact.name": "Votre nom",
    "contact.email": "Votre email",
    "contact.message": "Votre message",
    "contact.send": "Envoyer",
    "contact.sending": "Envoi...",
    "contact.sent": "Envoyé ✓",
    "contact.toast_success": "Message envoyé. Nous vous répondrons rapidement.",

    "stock.prefix": "Édition limitée · ",
    "stock.suffix": " pièces encore disponibles",
  },

  en: {
    "announce": "Free shipping on orders over €60 · Premium products · Visible results",

    "nav.accueil": "Home",
    "nav.femme": "Women",
    "nav.homme": "Men",
    "nav.coffrets": "Sets",
    "nav.serum": "The Serum",
    "nav.resultats": "Results",
    "nav.ingredients": "Ingredients",
    "nav.avis": "Reviews",
    "nav.faq": "FAQ",
    "nav.contact": "Contact",
    "nav.compte": "Account",
    "nav.recherche": "Search",
    "nav.panier": "Cart",

    "common.discover_serum": "Discover the serum",
    "common.learn_more": "Learn more",
    "common.add_to_cart": "Add to cart",
    "common.order": "Order now",
    "common.secure_payment": "Secure payment",
    "common.free_shipping": "Free shipping",

    "hero.tagline": "Skin & Hair Excellence",
    "hero.description": "The exceptional serum that hydrates, nourishes and strengthens your scalp for hair that looks stronger, denser and visibly healthier.",
    "hero.clients": "+1500 satisfied customers",

    "why.overline": "Why choose",
    "why.discover_formula": "Discover the formula",
    "why.key_ingredients": "Key ingredients",
    "why.free_claims": "Miel · Actifs fortifiants · Fini glossy premium",

    "results.title": "Visible results",
    "results.note": "*Consumer satisfaction study conducted over 8 weeks. Self-reported results, for reference only.",
    "results.before": "Before",
    "results.after": "After 8 weeks",
    "results.illustration": "Illustrative photos",

    "offer.overline": "Launch offer",
    "offer.desc": "Take advantage of our exclusive launch offer right now.",
    "offer.added": "Added to cart",
    "offer.free_ship_title": "Free shipping",
    "offer.free_ship_sub": "On orders over €60",
    "offer.secure_title": "Secure payment",
    "offer.secure_sub": "100% secure",
    "offer.guarantee_title": "Satisfied or refunded",
    "offer.guarantee_sub": "30 days",

    "footer.fast_ship": "Fast delivery",
    "footer.fast_ship_sub": "2 to 4 business days",
    "footer.support": "Customer service",
    "footer.support_sub": "Available 7 days a week",
    "footer.secure": "Secure payment",
    "footer.secure_sub": "100% secure",
    "footer.returns": "Easy returns",
    "footer.returns_sub": "30 days to change your mind",
    "footer.col_brand": "LUXE ORYVEA PREMIUM",
    "footer.our_story": "Our story",
    "footer.our_formula": "Our formula",
    "footer.contact": "Contact",
    "footer.help": "Help",
    "footer.delivery": "Delivery",
    "footer.returns_link": "Returns",
    "footer.cgv": "Terms & conditions",
    "footer.privacy": "Privacy policy",
    "footer.contact_form": "Contact form",
    "footer.ritual": "The Ritual",
    "footer.ritual_text": "Skin & Hair Excellence. The premium ritual for your scalp.",
    "footer.rights": "All rights reserved",

    "cart.empty_title": "Your cart is empty",
    "cart.empty_desc": "Discover the LUXE ORYVEA premium ritual.",
    "cart.title": "Your cart",
    "cart.title_order": "Checkout",
    "cart.promo": "Promo code",
    "cart.promo_placeholder": "Enter your code",
    "cart.apply": "Apply",
    "cart.applied": "Code applied",
    "cart.billing": "Billing & shipping address",
    "cart.summary": "Summary",
    "cart.subtotal": "Subtotal",
    "cart.discount": "Discount",
    "cart.shipping": "Shipping",
    "cart.offered": "Free",
    "cart.total": "Total",
    "cart.proceed": "Checkout",
    "cart.secure_btn": "Secure payment",
    "cart.redirect": "Redirecting...",
    "cart.secure_note": "Secure payment via Stripe",
    "field.first_name": "First name",
    "field.last_name": "Last name",
    "field.email": "Email address",
    "field.phone": "Phone number",
    "field.address": "Address",
    "field.postal_code": "Postal code",
    "field.city": "City",
    "field.country": "Country",

    "product.choose_format": "Choose your format",
    "product.save": "Save",
    "product.description": "The next generation of hair serum: immediate shine, mirror effect, honey nutrition and strengthening actives. A formula designed to support growth, care for the scalp and reveal softer, more resilient and visibly luminous hair.",
    "product.free_ship": "Free shipping",
    "product.secure": "100% secure payment",
    "product.adapted": "Suitable for various hair types",
    "product.actives": "The actives",
    "product.ingredients_title": "Carefully selected ingredients",
    "product.fragrance_title": "Signature fragrance",
    "product.fragrance_name": "Floral · Honeyed · Soft · Luminous",
    "product.fragrance_text": "A soft, luminous floral-honeyed signature that leaves the hair delicately scented.",
    "product.benefits": "Benefits",
    "product.usage": "How to use",
    "product.shipping_info": "Shipping information",
    "product.shipping_text": "Free shipping within mainland France. Shipped within 24–48 business hours. Secure payment.",
    "product.faq_title": "Frequently asked questions",
    "product.added": "added to cart",

    // Formula
    "formule.overline": "The formula",
    "formule.title": "Excellence at the heart of the formula",
    "formule.intro": "A blend of carefully selected active ingredients to care for the scalp and reveal hair that looks stronger, healthier and denser.",
    "formule.key_active": "Key active",
    "formule.disclaimer": "Cosmetic care. LUXE ORYVEA PREMIUM makes no medical promise or regrowth guarantee.",

    // Our story
    "marque.overline": "Our story",
    "marque.quote": "\u201cLUXE ORYVEA PREMIUM was born from a simple ambition: to turn everyday hair care into a true premium beauty ritual.\u201d",
    "marque.p1": "Every detail — from the formula to the bottle — was designed to deliver an experience worthy of the greatest cosmetic houses. The first chapter of this story is written around scalp care, the foundation of hair that looks stronger and denser.",
    "marque.p2": "Our approach blends elegance and rigor: carefully selected actives, a lightweight non-greasy texture, and a ritual that fits naturally into your daily life.",

    // Ritual
    "rituel.overline": "The daily gesture",
    "rituel.title_pre": "Your ",
    "rituel.title_suf": " ritual",
    "rituel.intro": "Three simple steps to bring premium care into your routine.",
    "rituel.cta": "Order the serum",

    // Sets
    "coffrets.overline": "The collection",
    "coffrets.title_pre": "Sets ",
    "coffrets.intro": "Premium gift sets to give or treat yourself — women, men or mixed.",
    "coffrets.out": "Sold out",
    "coffrets.lowstock": "Selling fast",
    "coffrets.add": "Add",
    "coffrets.only_left_pre": "Only ",
    "coffrets.only_left_suf": " left in stock",
    "coffrets.edition": "Premium edition",
    "coffrets.added": "added to cart",

    // Contact
    "contact.overline": "Contact",
    "contact.title": "Write to us",
    "contact.intro": "A question about the LUXE ORYVEA ritual? Our team is here to help.",
    "contact.name": "Your name",
    "contact.email": "Your email",
    "contact.message": "Your message",
    "contact.send": "Send",
    "contact.sending": "Sending...",
    "contact.sent": "Sent \u2713",
    "contact.toast_success": "Message sent. We'll get back to you shortly.",

    "stock.prefix": "Limited edition · ",
    "stock.suffix": " pieces still available",
  },
};
